import React from 'react'
import { AppFormItem } from 'api/index'
import './PropertyForm.less'
import { AppInput, AppSelect, AppRadio } from 'components/AppFormItem'
import { AppInputProps } from 'components/AppFormItem/AppInput'
import { AppSelectProps } from 'components/AppFormItem/AppSelect'
import { AppRadioProps } from 'components/AppFormItem/AppRadio'
import AppButton from 'components/AppFormItem/AppButton'
interface AppFormItemProps extends AppFormItem {
	render?: any
}
interface PropertyFormProps {
	onChange?: (propertyFormItem: AppFormItemProps, value: any, label?: string) => void
	formData: any
	propertyFormItemList: AppFormItemProps[]
}
export const PropertyForm = (props: PropertyFormProps) => {
	const renderControl = (propertyFormItem: AppFormItemProps) => {
		switch (propertyFormItem.type) {
			case 'Input':
				return (
					<AppInput
						{...{
							...(propertyFormItem as AppInputProps),
							value: props.formData[propertyFormItem.field] || '',
						}}
						onChange={(value: any) => {
							props.onChange && props.onChange(propertyFormItem, value)
						}}
					/>
				)
			case 'Select':
				return (
					<AppSelect
						{...{
							...(propertyFormItem as AppSelectProps),
							value: props.formData[propertyFormItem.field],
							label: props.formData[propertyFormItem.textField],
						}}
						onChange={(value: any, label: string) => {
							props.onChange && props.onChange(propertyFormItem, value, label)
						}}
					/>
				)
			case 'Radio':
				return (
					<AppRadio
						{...{
							...(propertyFormItem as AppRadioProps),
							value: props.formData[propertyFormItem.field] || false,
						}}
						onChange={(value: any, label: string) => {
							props.onChange && props.onChange(propertyFormItem, value, label)
						}}
					/>
				)
			case 'Button':
				return (
					<AppButton
						{...(propertyFormItem as AppRadioProps)}
						onClick={(e: any) => {
							props.onChange && props.onChange(propertyFormItem, '')
						}}
					/>
				)
			default:
				return (
					<AppInput
						{...{
							...(propertyFormItem as AppInputProps),
							value: props.formData[propertyFormItem.field] || '',
						}}
						onChange={(value: any) => {
							props.onChange && props.onChange(propertyFormItem, value)
						}}
					/>
				)
		}
	}
	return (
		<div className="property-form">
			<div className="property-form-content">
				{props.propertyFormItemList.map((propertyFormItem: AppFormItemProps) => {
					return (
						<div key={propertyFormItem.field} className="property-form-item">
							<div className="property-form-item-content">
								{propertyFormItem.labelHidden ? (
									''
								) : (
									<div className="property-form-item-label">
										{propertyFormItem.label}
										{propertyFormItem.req ? (
											<span className="property-form-item-required">*</span>
										) : (
											''
										)}
									</div>
								)}

								<div className="property-form-item-control">
									{propertyFormItem.render
										? propertyFormItem.render
										: renderControl(propertyFormItem)}
								</div>
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export const EmptyPropertyForm = () => {
	return <div className="empty-property-form">请先在左侧选择一个组件</div>
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/PropertyForm.tsx